import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FeaturePath } from '@shared/enum/featurePath.enum';
import { CloseScreenComponent } from '@shared/pages/closeScreen/closeScreen.component';
import { EntryScreenComponent } from '@shared/pages/entryComponentScreen/entryScreen.component';
import { ErrorScreenComponent } from '@shared/pages/error/error.component';
import { RouteGuardService } from './core/services/routeGuard.service';

const routes: Routes = [
  {
    path: FeaturePath.RSA_CASE_CREATION,
    loadChildren: () => import('./features/case/modules/rsa/rsaCase/rsaCase.module').then((m) => m.RsaCaseModule),
    canActivate: [RouteGuardService],
    canActivateChild: [RouteGuardService]
  },
  {
    path: FeaturePath.RSA_CASE_CREATION_V2,
    loadChildren: () => import('./features/case/modules/rsa/rsaCaseV2/rsaCaseV2.module').then((m) => m.RsaCaseV2Module),
    canActivate: [RouteGuardService],
    canActivateChild: [RouteGuardService]
  },
  {
    path: FeaturePath.RSA_CASE_CREATION_TOKEN,
    loadChildren: () => import('./features/case/modules/rsa/rsaCase/rsaCase.module').then((m) => m.RsaCaseModule),
    canActivate: [RouteGuardService],
    canActivateChild: [RouteGuardService]
  },
  {
    path: FeaturePath.RSA_EXTRA_PAYMENT,
    loadChildren: () => import('./features/extraPayment/modules/rsa/rsaExtraPayment.module').then((m) => m.RsaExtraPaymentModule)
  },
  {
    path: FeaturePath.RSA_VB_WEBCHAT,
    loadChildren: () => import('./features/vbWebchat/modules/rsa/rsaVbWebchat.module').then((m) => m.RsaVbWebchatModule)
  },
  {
    path: FeaturePath.RSA_TRACKING,
    loadChildren: () => import('./features/tracking/tracking.module').then((m) => m.TrackingModule),
    canActivate: [RouteGuardService]
  },
  {
    path: FeaturePath.RSA_RATING,
    loadChildren: () => import('./features/rating/rating.module').then((m) => m.RatingModule),
    canActivate: [RouteGuardService]
  },
  {
    path: FeaturePath.RSA_REIMBURSEMENT,
    loadChildren: () => import('./features/reimbursement/modules/rsa/rsaReimbursement.module').then((m) => m.RsaReimbursementModule),
    canActivate: [RouteGuardService],
    canActivateChild: [RouteGuardService]
  },
  {
    path: FeaturePath.HOME_REIMBURSEMENT,
    loadChildren: () => import('./features/reimbursement/modules/home/homeReimbursement.module').then((m) => m.HomeReimbursementModule)
  },
  {
    path: FeaturePath.HOME_VB_WEBCHAT,
    loadChildren: () => import('./features/vbWebchat/modules/home/homeVbWebchat.module').then((m) => m.HomeVbWebchatModule)
  },
  {
    path: FeaturePath.RSA_FOLLOW_UP,
    loadChildren: () => import('./features/followUp/modules/rsa/rsaFollowUp.module').then((m) => m.RsaFollowUpModule)
  },
  {
    path: FeaturePath.HOME_FOLLOW_UP,
    loadChildren: () => import('./features/followUp/modules/home/homeFollowUp.module').then((m) => m.HomeFollowUpModule)
  },
  { path: 'error', component: ErrorScreenComponent },
  { path: 'error/:id', component: ErrorScreenComponent },
  { path: 'close/:url', component: CloseScreenComponent },
  { path: '**', pathMatch: 'full', component: EntryScreenComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
